import { Box } from '@material-ui/core';
import { BusinessOnboardingDetails, HolderType } from '@nemuru-eng/js-api-client';

import { BusinessAddressDetails } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessAddressDetails/BusinessAddressDetails';
import { BusinessFinancialDetails } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessFinancialDetails/BusinessFinancialDetails';
import { BusinessIdentification } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/BusinessIdentification';
import { Holders } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/Holders/Holders';
import { BorrowerInvitationSection } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/BorrowerInvitationSection';

interface BusinessKYCProps {
  loanId: string;
  onboardingDetails: BusinessOnboardingDetails;
  editModeAllowed?: boolean;
}

export const BusinessKYC = ({ loanId, onboardingDetails, editModeAllowed }: BusinessKYCProps) => {
  const borrowerInvitation = onboardingDetails.invitation;
  const holders = onboardingDetails.holders;

  const existingHolderTypes: HolderType[] = getExistingTypesFromHolders(holders);

  return (
    <>
      <BorrowerInvitationSection borrowerInvitation={borrowerInvitation} editModeAllowed={editModeAllowed} />
      <Box mt={3} />
      <BusinessIdentification
        loanId={loanId}
        businessOnboarding={onboardingDetails}
        editModeAllowed={editModeAllowed}
      />
      <Box mt={3} />
      <BusinessFinancialDetails
        loanId={loanId}
        businessOnboarding={onboardingDetails}
        editModeAllowed={editModeAllowed}
      />
      <Box mt={3} />
      <BusinessAddressDetails
        loanId={loanId}
        businessOnboarding={onboardingDetails}
        editModeAllowed={editModeAllowed}
      />
      <Box mt={3} />
      {existingHolderTypes.map((holderType) => (
        <Holders
          loanId={loanId}
          id={onboardingDetails.id}
          holders={holders}
          editModeAllowed={editModeAllowed}
          holderType={holderType}
        />
      ))}
    </>
  );
};

const getExistingTypesFromHolders = (holders: BusinessOnboardingDetails['holders']): HolderType[] => {
  const allTypes = new Set<HolderType>();

  holders.forEach((holder) => {
    holder.types.forEach((type) => {
      allTypes.add(type);
    });
  });

  return Array.from(allTypes);
};
